<template>
    <div>
        <div class="columns is-mobile">
            <div class="column">
                <p class="title has-text-left">Edit Method Details</p> 
            </div>
        </div>    

        <div class="tile is-ancestor">
            <div class="tile is-12 is-horizontal is-parent">
                <div class="tile is-child box"> 
                    <div class="column">
                        <b-field class="has-text-left" label="Method name">
                            <b-input name="method_name" v-model="currentMethod.name" placeholder="Method name"></b-input>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field class="has-text-left" label="Concentration unit">
                            <b-input name="concentration_unit" v-model="currentMethod.concentration_unit" placeholder="Concentration unit"></b-input>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field class="has-text-left" label="Area unit">
                            <b-input name="area_unit" v-model="currentMethod.area_unit" placeholder="Area unit"></b-input>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field class="has-text-left" label="Retention time unit">
                            <b-input name="retention_time_unit" v-model="currentMethod.retention_time_unit" placeholder="Retention time unit"></b-input>
                        </b-field>
                    </div>

                    <div class="column">
                        <div class="field has-text-left">
                            <label class="label">Description</label>
                            <div class="control">
                                <textarea class="textarea" v-model="currentMethod.method_description" placeholder="Textarea"></textarea>
                            </div>
                        </div>
                    </div>             
                </div>          
            </div>
        </div>      

        <div class="tile is-ancestor">
            <div class="tile is-12 is-horizontal is-parent">
                <!-- Table start -->
                <div class="tile is-child box">  
                    <!-- Add Analytes Form start -->
                    <p class="subtitle has-text-left">Add Analyte</p>                 
                    
                    <table class="table">
                        <tbody>
                            <tr>
                            <td><b-input v-model="short_name" name="short_name" placeholder="Short Name"></b-input></td>
                            <td><b-input v-model="official_name" name="official_name" placeholder="Official Name"></b-input></td>
                            <td><b-input v-model="abbreviation" name="abbreviation" placeholder="Abbreviation"></b-input></td>
                            <td><b-input v-model="target_concentration" name="target_concentration" placeholder="Target Concentration"></b-input></td>
                            <td>
                                <a class="button is-primary" v-on:click="addAnalytes()">
                                    <span>Add</span>
                                    <span class="icon is-small">
                                    <i class="fas fa-arrow-circle-right"></i>
                                    </span>
                                </a>
                            </td>                            
                            </tr>
                        </tbody>
                    </table>   
                    <hr> 
                    <!-- Add Analytes Form end -->  

                    <p class="subtitle has-text-left">All Analytes</p>                           
                    <b-table
                        :data="isEmpty ? [] : currentMethod.analytes"
                        :striped=false
                        :hoverable=true
                        :loading="isLoading"
                        :mobile-cards=true>

                        <template slot-scope="props"> 
                            <b-table-column field="short_name" label="Short Name">
                                <!-- {{ props.row.short_name }} -->
                                <b-field>
                                    <b-input v-model="props.row.short_name"></b-input>
                                </b-field>
                            </b-table-column>
                            
                            <b-table-column field="official_name" label="Official Name">
                                <!-- {{ props.row.official_name }} -->
                                <b-field>
                                    <b-input v-model="props.row.official_name"></b-input>
                                </b-field>
                            </b-table-column>

                            <b-table-column field="abbreviation" label="Abbreviation" centered>
                                <!-- {{ props.row.abbreviation }} -->
                                <b-field>
                                    <b-input v-model="props.row.abbreviation"></b-input>
                                </b-field>
                            </b-table-column>

                            <b-table-column field="target_concentration" label="Target Concentration" centered>
                                <!-- {{ props.row.target_concentration }} -->
                                <b-field>
                                    <b-input v-model="props.row.target_concentration"></b-input>
                                </b-field>
                            </b-table-column>

                            <b-table-column field="action" label="Action" centered>
                                <a class="button is-small is-inverted is-danger" @click="deleteAnalyte(props.row)">
                                    <span>Delete</span>
                                </a>
                            </b-table-column>
                        </template>

                        <template slot="empty">
                            <div v-if="Object.keys(currentMethod).length === 0">
                                <b-table
                                    :loading="true"
                                    :focusable="true"
                                    :mobile-cards="true">

                                    <template slot-scope="props"> 
                                    </template>
                                </b-table>                                
                            </div>

                            <div v-else>
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                            icon="emoticon-sad"
                                            size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>No Analytes... Use the form on the left to add some</p>
                                </div>
                            </div>
                            
                        </template>
                    </b-table>
                </div>      
                <!-- Table end -->    
            </div>
        </div>

        <!-- Uploads start -->
        <div class="tile is-ancestor">
            <div class="tile is-12 is-vertical is-parent">
                <div class="tile is-child box"> 

                    <div class="column">
                        <p class="subtitle has-text-left">Method File (.zip):</p> 
                        <div class="file is-primary has-name  is-fullwidth">
                            <label class="file-label">
                            <!-- file -->
                            <input class="file-input" accept=".zip" type="file" ref="methodFileRef" v-on:change="methodFileUpload()">
                            <!--  -->
                            <span class="file-cta">
                                <span class="file-icon">
                                <i class="fas fa-upload"></i>
                                </span>
                                <span class="file-label">
                                Choose a file…
                                </span>
                            </span>
                            <span class="file-name">
                                {{methodFilename}}
                            </span>
                            </label>
                        </div>
                        <div style="margin-top:10px" v-if="methodFile!='' && !methodFile.type.includes('zip')">
                            <b-message type="is-danger">
                                Incorrect format of file. Select the correct format of file.
                            </b-message>
                        </div>
                    </div>     
                </div>   
                
                <div class="tile is-child box">                    
                    <div class="column">
                        <p class="subtitle has-text-left">Method Description file (.pdf): </p> 
                        <div class="file is-primary has-name  is-fullwidth">
                            <label class="file-label">
                            <!-- file -->
                            <input class="file-input" type="file" accept=".pdf" ref="methodDescFileRef" v-on:change="methodDescFileUpload()">
                            <!--  -->
                            <span class="file-cta">
                                <span class="file-icon">
                                <i class="fas fa-upload"></i>
                                </span>
                                <span class="file-label">
                                Choose a file…
                                </span>
                            </span>
                            <span class="file-name">
                                {{methodDescFilename}}
                            </span>
                            </label>
                        </div>
                        <div style="margin-top:10px" v-if="methodDescFile!='' && !methodDescFile.type.includes('pdf')">
                            <b-message type="is-danger">
                                Incorrect format of file. Select the correct format of file.
                            </b-message>
                        </div>
                    </div>                

                </div>       
            </div>
        </div> 
        <!-- Uploads end -->     

            
        <!-- Action buttons -->
        <span class="is-pulled-right">
            <a class="button is-large is-primary" @click="submitEditedMethod()">
                <span>Update</span>
            </a>
            <span style="margin-left:20px"></span>

            <!-- @click="$router.go(-1) take you to previous router-link component :) -->
            <a class="button is-large" @click="back()">
                <span>Cancel</span>
            </a>
        </span>
        <!-- <span style="margin-left:20px"></span> -->
        <a class="button is-warning is-pulled-left is-large" @click="submitArchivedMethod()">
            <span>Archive</span>
        </a>
        <!--  -->  
    </div>
</template>


<script>
export default {
    name: "EditMethodComponent",
    props: ["currentMethod"],

    data: function() {
        return {
            // 
            // table
            analytesData:[],
            isEmpty: false,
            isLoading: false,
            isOpenActive: true,
            isOpenArchived: false,
            // Files
            methodFile: '',
            methodFilename:'',
            methodDescFile: '',
            methodDescFilename: '',
            // Analyets variables
            short_name:"",
            official_name:"",
            abbreviation:"",
            target_concentration:""
        }
    },
    methods: {
        addAnalytes: function() {
            console.log("short name: ", this.short_name)
            var newAnalyte = {                
                abbreviation: this.abbreviation,
                target_concentration: this.target_concentration,
                official_name: this.official_name,
                short_name: this.short_name
            }
            this.currentMethod.analytes.push(newAnalyte)
            console.log("New analytes: ", this.currentMethod.analytes)
            this.clearAnalytesForm()
        },

        editAnalyte: function(currentAnalyte) {
            this.short_name = currentAnalyte.short_name
            this.official_name = currentAnalyte.official_name
            this.abbreviation = currentAnalyte.abbreviation
            this.target_concentration = currentAnalyte.target_concentration

            var index = this.currentMethod.analytes.indexOf(currentAnalyte)
            this.currentMethod.analytes.splice(index, 1);
        },

        deleteAnalyte: function(currentAnalyte) {
            var index = this.currentMethod.analytes.indexOf(currentAnalyte)
            this.currentMethod.analytes.splice(index, 1);
        },

        clearAnalytesForm: function() {
            this.short_name = ''
            this.official_name = ''
            this.abbreviation = ''
            this.target_concentration = ''
        },

        methodFileUpload: function() {
            this.methodFile = this.$refs.methodFileRef.files[0]
            this.methodFilename = this.$refs.methodFileRef.files[0].name
        },
        methodDescFileUpload: function() {
            this.methodDescFile = this.$refs.methodDescFileRef.files[0]
            this.methodDescFilename = this.$refs.methodDescFileRef.files[0].name
        },
        submitEditedMethod: function(){
            if(this.methodFile.name){
                if(!this.methodFile.type.includes("zip")){
                    this.$toast.open({
                        message: `Provide correct format of files to continue`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                } else{
                    this.currentMethod.method_file = this.methodFile
                }
            }
            else {
                delete this.currentMethod.method_file
            }

            if(this.methodDescFile.name){                
                if(!this.methodDescFile.type.includes("pdf")){
                    this.$toast.open({
                        message: `Provide correct format of files to continue`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                } else{
                    this.currentMethod.method_description_file = this.methodDescFile
                }
            }
            else {
                delete this.currentMethod.method_description_file
            }                         
            this.$emit("submitEditedMethod", this.currentMethod)
        },
        submitArchivedMethod: function(){  
            // console.log("Comp-Edit method data: ", this.currentMethod)
            this.$emit("submitArchivedMethod", this.currentMethod)
        },
        back: function() {
            this.$emit("back", this.currentMethod);
        }
    }
}
</script>
